import React from 'react';
import SimpleFooterCTA from 'components/SimpleFooterCTA';

const BlogFooter = ({ cta }) =>
  cta && cta.length > 0 ? (
    <footer>
      <SimpleFooterCTA {...cta[0]} />
    </footer>
  ) : null;

export default BlogFooter;
